module.exports = __webpack_public_path__ + "img/temoignage-6.77b7b58c.jpg";